module.exports = {
  context: {
    hash: 'abc123',
    image: {
      src: 'https://via.placeholder.com/600',
      alt: 'lorem ipsum dolor sit amet',
      lazy: true,
      width: 600,
      height: 600
    },
    heading: 'First Name Last Name',
    title: 'Title',
    date: 'Joined in 1994',
    text: '<p>Aliquam sed diam rhoncus, fermentum ante eget, malesuada magna. Proin porta finibus quam, sed venenatis orci consequat at. Suspendisse potenti. Aenean tincidunt, justo at fringilla congue, eros ligula pretium elit, ac scelerisque mi nulla sit amet massa. Morbi malesuada pulvinar ex in feugiat. Praesent rutrum iaculis risus, non commodo nisi condimentum id. Aenean viverra fringilla sapien, fermentum consectetur ipsum finibus sit amet. Curabitur mollis consectetur molestie. Curabitur cursus maximus tellus sed euismod. Vivamus dignissim justo eu lorem mollis, et maximus nunc efficitur. Duis iaculis quis massa at imperdiet. Aenean facilisis viverra magna, ut convallis eros tempus eu.</p>',
    button: 'Bio'
  }
}
